// Vehicle state for TraKing-linked accounts, derived the same way TraKing's
// Monitoring page does it: from the latest packet's ACC and speed.
//   ACC on  + speed > 0  -> moving
//   ACC on  + speed = 0  -> idle
//   ACC off + speed = 0  -> parked
// A vehicle is only "offline" when it has no packet at all. TraKing's backend
// `current_state` is NOT used here: it marks a vehicle offline after 30 minutes
// without a packet, which makes TrackRight disagree with TraKing's own screen.
//
// Set OFFLINE_AFTER_MINUTES (e.g. 30) to also treat vehicles whose last packet
// is older than that as offline.
const OFFLINE_AFTER_MINUTES = null;

export const deriveVehicleState = (row = {}) => {
  const hasPacket =
    row.id != null || row.last_ping != null || row.acc_status != null;
  if (!hasPacket) return "offline";

  if (OFFLINE_AFTER_MINUTES) {
    const ref = new Date(row.device_datetime_utc || row.last_ping).getTime();
    if (Number.isNaN(ref) || Date.now() - ref > OFFLINE_AFTER_MINUTES * 60000) {
      return "offline";
    }
  }

  const accOn =
    row.acc_status === true ||
    row.acc_status === "1" ||
    String(row.acc_status) === "true";
  const speed = parseFloat(row.speed) || 0;

  if (accOn && speed > 0) return "moving";
  if (accOn) return "idle";
  return "parked";
};
